<ng-container *ngIf="shouldShowMessage">
    <div
        class="message-container"
        *ngIf="showRequestedMessage()"
        [ngClass]="{ 'disabled-overlay': isProjectPendingApproval() }">
        <div class="text-container">
            <mat-icon svgIcon="lock-profile" />

            <div class="title-version-container">
                <div class="message-title">
                    {{
                        'vessel.page.message.ownership.request.title'
                            | translate: { userName: ownershipTransfer?.userName }
                    }}
                </div>
            </div>

            <div>
                <div class="text-message">
                    {{
                        'vessel.page.message.ownership.request.message'
                            | translate: { userName: ownershipTransfer?.userName }
                    }}
                </div>
            </div>
        </div>

        <div *ngIf="ownershipTransfer?.comment" class="text-message bold">
            {{ 'vessel.page.message.comment' | translate }}
        </div>
        <div *ngIf="ownershipTransfer?.comment" class="text-message">
            {{ ownershipTransfer?.comment }}
        </div>

        <div class="buttons-container">
            <div class="reject button" (click)="onReject()">
                {{ 'vessel.page.message.ownership.request.reject' | translate }}
            </div>
            <div class="approve button" [ngClass]="{ 'disabled-button': hasEditor() }" (click)="onApprove()">
                {{ 'vessel.page.message.ownership.request.accept' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showClaimedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="lock-profile" />
            <div class="message-title">
                {{ 'vessel.page.message.ownership.claimed.title' | translate }}
            </div>
            <div class="text-message">
                {{ 'vessel.page.message.ownership.claimed.message' | translate }}
            </div>
        </div>

        <div class="buttons-container">
            <div class="button" (click)="closeMessage()">
                {{ 'vessel.page.message.ownership.claimed.close' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showAssignedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="lock-profile" />
            <div class="message-title">
                {{ 'vessel.page.message.ownership.assigned.title' | translate: { userName: assignerName } }}
            </div>
            <div class="text-message">
                {{ 'vessel.page.message.ownership.assigned.message' | translate }}
            </div>
        </div>

        <div *ngIf="ownershipTransfer?.comment" class="text-message bold">
            {{ 'vessel.page.message.comment' | translate }}
        </div>
        <div *ngIf="ownershipTransfer?.comment" class="text-message">
            {{ ownershipTransfer?.comment }}
        </div>

        <div class="buttons-container">
            <div class="button" (click)="closeMessage()">
                {{ 'vessel.page.message.ownership.assigned.close' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showRejectedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />
            <div class="message-title">
                {{ 'vessel.page.message.ownership.rejected.title' | translate: { userName: assignerName } }}
            </div>
            <div class="text-message">
                {{ 'vessel.page.message.ownership.rejected.message' | translate }}
            </div>
        </div>
        <div class="buttons-container">
            <div class="button" (click)="closeMessage()">
                {{ 'vessel.page.message.ownership.rejected.close' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showOwnerRemovedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />
            <div class="message-title">
                {{ 'vessel.page.message.ownership.removed.title' | translate }}
            </div>
            <div class="text-message">
                {{ 'vessel.page.message.ownership.removed.message' | translate }}
            </div>
        </div>
        <div class="buttons-container">
            <div class="button" (click)="closeMessage()">
                {{ 'vessel.page.message.ownership.removed.close' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showOwnerLeftMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="lock-profile" class="approval-icon" />
            <div class="message-title">
                {{ 'vessel.page.message.owner-left.title' | translate: { userName: ownershipTransfer?.userName } }}
            </div>
        </div>
        <div *ngIf="ownershipTransfer?.comment" class="text-message bold">
            {{ 'vessel.page.message.comment' | translate }}
        </div>
        <div *ngIf="ownershipTransfer?.comment" class="text-message">
            {{ ownershipTransfer?.comment }}
        </div>
    </div>
</ng-container>
